import {
  SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL,
  SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL,
  SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL,
  CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL,
  SET_STATES_FOR_ADMIN_ENTRY_DETAIL,
  SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL,
  SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL,
  UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL,
  SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL,
  SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL,
  SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL,
  MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL,
  MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL,
  SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION,
  SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION,
  SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL,
  SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL,
  SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN,
  SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN,
  DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL,
  SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL,
  CANCEL_ENTRY_DETAIL_PAYMENT_MODAL,
  DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL,
  HIDE_ENTRY_DETAIL_PAYMENT_MODAL,
  SET_ENTRY_DETAIL_ID_FOR_ADMIN,
  SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN,
  DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL,
  DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL,
  SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN,
  SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN,
  SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN,
  SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  SET_IS_NEW_CAPTAIN_ENTRY_DETAIL,
  SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL,
  SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN,
  SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS,
  SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN,
  SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE
} from './constants';

import {blankRosterPosition} from './dataModel';

export const initialState = {
  balance: 0,
  bowlers: [],
  captainId: '',
  coordinator: {},
  captain: {},
  countries: [],
  disableState: false,
  divisionName: '',
  entryId: '',
  entryNumber: '',
  groupCode: '',
  isCancelled: false,
  pairCode: '',
  paymentLog: {},
  readOnly: false,
  readOnlyInfo: {},
  rosterPositions: [],
  squadDateTime: '',
  showEntryDetailCoordinatorModal: false,
  showEntryDetailCaptainModal: false,
  showEntryDetailChangeCaptainModal: false,
  isNew: false,
  showEntryDetailPaymentModal: false,
  showEntryRosterModal: false,
  showPaymentLog: false,
  showSquadChangeModal: false,
  showEventChangeModal: false,
  showEntryDetailRefundModal: false,
  states: [],
  virtualEntriesToModify: [],
  teamName: '',
  timeZoneDisplayName: '',
  tournament: {},
  showReactivationModal: false,
  refundType: 'refundOnly'
};

export const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_AVAILABLE_BOWLERS_FOR_ADMIN_ENTRY_DETAIL: {
      return {
        ...state,
        bowlers: payload || initialState.bowlers
      };
    }
    case SET_STATE_DISABLED_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        disableState: payload || false
      };
    case SET_READONLY_INFO_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        readOnlyInfo: payload || initialState.readOnlyInfo
      };
    case SET_SUMMARY_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        entryNumber: payload.entryNumber || initialState.entryNumber,
        groupCode: payload.groupCode || initialState.groupCode,
        pairCode: payload.pairCode || initialState.pairCode,
        readOnly: payload.readOnly || initialState.readOnly,
        teamName: payload.teamName || initialState.teamName,
        divisionName: payload.divisionName || initialState.divisionName,
        timeZoneDisplayName: payload.timeZoneDisplayName || initialState.timeZoneDisplayName,
        squadDateTime: payload.squadDateTime || initialState.squadDateTime,
        eventId: payload.eventId || initialState.eventId,
        isCancelled: payload.isCancelled || initialState.isCancelled
      };
    case CLEAR_ROSTER_POSITION_FOR_ADMIN_ENTRY_DETAIL:
      return !isNaN(Number(payload))
        ? {
          ...state,
          rosterPositions: state.rosterPositions.map((x, i) => i === Number(payload)
            ? {
              ...x,
              ...blankRosterPosition,
              averageRequired: x.averageRequired,
              _errorMessage: null
            }
            : x)
        }
        : state;
    case SET_STATES_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        states: payload || initialState.states
      };
    case SET_VIRTUAL_ENTRIES_TO_MODIFY_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        virtualEntriesToModify: payload || initialState.virtualEntriesToModify
      };
    case SET_COUNTRIES_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        countries: payload || initialState.countries
      };
    case MOVE_ROSTER_POSITION_UP_FOR_ADMIN_ENTRY_DETAIL: {
      const currentPosition = payload;

      if(typeof currentPosition === 'undefined' || currentPosition <= 0) {
        return state; // do nothing if first in array
      }

      const rosters = [...state.rosterPositions];
      const tmp = rosters[currentPosition];

      // swap positions with correct position number
      rosters[currentPosition] = {
        ...rosters[currentPosition - 1],
        position: rosters[currentPosition - 1].position + 1
      };
      rosters[currentPosition - 1] = {
        ...tmp,
        position: tmp.position - 1
      };
      return {
        ...state,
        rosterPositions: rosters
      };
    }
    case MOVE_ROSTER_POSITION_DOWN_FOR_ADMIN_ENTRY_DETAIL: {
      const currentPosition = payload;

      if(typeof currentPosition === 'undefined' || currentPosition >= state.rosterPositions.length) {
        return state; // do nothing if last in array
      }

      const rosters = [...state.rosterPositions];
      const tmp = rosters[currentPosition];

      // swap positions with correct position
      rosters[currentPosition] = {
        ...rosters[currentPosition + 1],
        position: rosters[currentPosition + 1].position - 1
      };
      rosters[currentPosition + 1] = {
        ...tmp,
        position: tmp.position + 1
      };
      return {
        ...state,
        rosterPositions: rosters
      };
    }
    case UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL:
    case SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL:
    case SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL:
    case SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL:
    case SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION:
    case SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION:
      return {
        ...state,
        rosterPositions: state.rosterPositions.map(x => rosterPositionReducer(x, {type, payload}))
      };
    case SET_ROSTER_POSITIONS_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        rosterPositions: payload || initialState.rosterPositions
      };
    case SET_ROSTER_MODAL_VISIBILITY_FOR_ADMIN_ENTRY_DETAIL:
      return {
        ...state,
        showEntryRosterModal: payload || initialState.showEntryRosterModal
      };
    case DISPLAY_ENTRY_DETAIL_CHANGE_SQUAD_MODAL: {
      return {
        ...state,
        showSquadChangeModal: payload || initialState.showSquadChangeModal
      };
    }
    case DISPLAY_ENTRY_DETAIL_CHANGE_EVENT_MODAL: {
      return {
        ...state,
        showEventChangeModal: payload || initialState.showEventChangeModal
      };
    }
    case SET_ENTRY_DETAIL_BALANCE_FOR_ADMIN: {
      return {
        ...state,
        balance: payload || initialState.balance
      };
    }
    case SET_ENTRY_DETAIL_CAPTAINID_FOR_ADMIN: {
      return {
        ...state,
        captainId: payload || initialState.captainId
      };
    }
    case SET_ENTRY_DETAIL_ID_FOR_ADMIN: {
      return {
        ...state,
        entryId: payload || initialState.entryId
      };
    }
    case SET_ENTRY_DETAIL_TOURNAMENT_FOR_ADMIN: {
      return {
        ...state,
        tournament: payload || initialState.tournament
      };
    }
    case SET_ENTRY_DETAIL_COORDINATOR_FOR_ADMIN: {
      return {
        ...state,
        coordinator: payload || initialState.coordinator
      };
    }
    case SET_ENTRY_DETAIL_CAPTAIN_FOR_ADMIN: {
      return {
        ...state,
        captain: payload || initialState.captain
      };
    }
    case SET_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL: {
      return {
        ...state,
        paymentLog: payload
      };
    }
    case DISPLAY_PAYMENT_LOG_HISTORY_FOR_ADMIN_ENTRY_DETAIL: {
      return {
        ...state,
        showPaymentLog: (payload == null) ? !state.showPaymentLog : payload
      };
    }
    case CANCEL_ENTRY_DETAIL_PAYMENT_MODAL: {
      return {
        ...state,
        showEntryDetailPaymentModal: false
      };
    }
    case DISPLAY_ENTRY_DETAIL_PAYMENT_MODAL: {
      return {
        ...state,
        showEntryDetailPaymentModal: true
      };
    }
    case HIDE_ENTRY_DETAIL_PAYMENT_MODAL: {
      return {
        ...state,
        showEntryDetailPaymentModal: false
      };
    }
    case SHOW_HIDE_ENTRY_DETAIL_COORDINATOR_MODAL_FOR_ADMIN: {
      return {
        ...state,
        showEntryDetailCoordinatorModal: payload
      };
    }
    case SHOW_HIDE_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN: {
      return {
        ...state,
        showEntryDetailChangeCaptainModal: payload
      };
    }
    case SET_IS_NEW_CAPTAIN_ENTRY_DETAIL: {
      return {
        ...state,
        isNew: payload
      };
    }
    case SHOW_HIDE_ENTRY_DETAIL_REFUND_MODAL_FOR_ADMIN: {
      return {
        ...state,
        showEntryDetailRefundModal: payload
      };
    } 
    case SET_ENTRY_DETAIL_CREDIT_PURCHASE_TRANSACTIONS: {
      return {
        ...state,
        creditPurchaseTransactions: payload
      };
    }
    case SHOW_HIDE_ENTRY_DETAIL_REACTIVATION_MODAL_FOR_ADMIN: {
      return {
        ...state,
        showReactivationModal: payload
      };
    }
    case SET_ADMIN_ENTRY_DETAIL_REFUND_TYPE: {
      return {
        ...state,
        refundType: payload
      };
    }
    default:
      return state;
  }
};

const rosterPositionReducer = (state = {}, {type, payload}) => {
  switch (type) {
  case UPDATE_ROSTER_INFO_FOR_ADMIN_ENTRY_DETAIL:
  {
    if (state.position !== payload.position) return state;
    let searchChanged = state._searchChanged;

    if (!payload._errorMessage) {
      searchChanged = false;
    } 
    return {
      ...state,
      ...payload,
      _retrieved: !payload._errorMessage,
      _searchChanged: searchChanged
    };
  }
  case SEARCHING_MEMBER_FINISHED_FOR_ADMIN_ENTRY_DETAIL:
    return {
      ...state,
      _processing: false
    };
  case SEARCHING_MEMBER_STARTS_FOR_ADMIN_ENTRY_DETAIL:
    return {
      ...state,
      _processing: state.position === payload.position
    };
  case SET_MEMBER_SEARCH_FIELD_FOR_ADMIN_ENTRY_DETAIL:
  {
    if (state.position !== payload.position) return state;
    return {
      ...state,
      _searchValue: payload._searchValue,
      _searchChanged: true,
      usbcIdError: false
    };
  }
  case SET_BOWLER_AVG_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION:
      return state.position === payload.position
        ? {
          ...state,
          bowler: {
            ...state.bowler,
            average: payload.value
          }
        }
        : state;
    case SET_IS_PROFESSIONAL_FOR_ADMIN_ENTRY_DETAIL_ROSTER_POSITION:
      return state.position === payload.position
        ? {
          ...state,
          bowler: {
            ...state.bowler,
            isProfessional: Boolean(payload.value)
          }
        }
        : state;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/reducer.js